<template>
  <svg :width="width" :height="width" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>ic_common_icon_back</title>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"
      stroke-linejoin="round">
      <g id="落地页-添加好友" transform="translate(-28.000000, -107.000000)" :stroke="color" stroke-width="4">
        <g id="tab-content" transform="translate(0.000000, 88.000000)">
          <g id="ic_common_icon_back" transform="translate(28.000000, 19.000000)">
            <polyline id="路径-30" points="32 12 19 25 32 38"></polyline>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SvgLeftArrow',
  props: {
    color: {
      type: String as PropType<string>,
      default: '#2F2F2F'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
})
</script>
